<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Timesheet</h1>
    <p>Qtac provides a standardised timesheet for companies to complete, do you have any custom timesheet requirements?.</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.hasOwnTimesheetFormat">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.hasOwnTimesheetFormat">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref,  } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object
})

const validateStep = () => {
  if (props.formData.hasOwnTimesheetFormat === undefined || props.formData.hasOwnTimesheetFormat === null || props.formData.hasOwnTimesheetFormat === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}


const executeStep = async () => {
  return true;
}




defineExpose({ validateStep, executeStep });

</script>